<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <loader :active="loading"/>
        <div class="row" v-if="!loading">
            <div class="col-md-12 d-md-none mt-3">
                <h3>Statystyki</h3>
                <hr>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-users h2 text-primary align-middle mb-0 mr-3"></i> Klientów online
                        </p>
                        <div class="row">
                            <div class="col-4 d-flex justify-content-center align-items-center">
                                <h3>{{ data.serverStats[0].online }}</h3>
                            </div>
                            <div class="col-8">
                                <div>
                                    <apexchart
                                        v-if="!loading"
                                        class="apex-charts"
                                        height="40"
                                        type="area"
                                        dir="ltr"
                                        :series="series.online"
                                        :options="chartOptions"
                                    ></apexchart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-hourglass-end h2 text-primary align-middle mb-0 mr-3"></i> Ping serwera
                        </p>

                        <div class="row">
                            <div class="col-4 d-flex justify-content-center align-items-center">
                                <h3>{{ data.serverStats[0].ping }} ms</h3>
                            </div>
                            <div class="col-8">
                                <div>
                                    <apexchart
                                        v-if="!loading"
                                        class="apex-charts"
                                        height="40"
                                        type="area"
                                        dir="ltr"
                                        :series="series.ping"
                                        :options="chartOptions"
                                    ></apexchart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-ghost h2 text-primary align-middle mb-0 mr-3"></i> Utrata pakietów
                        </p>

                        <div class="row">
                            <div class="col-4 d-flex justify-content-center align-items-center">
                                <h3>{{ data.serverStats[0].packet_loss }}%</h3>
                            </div>
                            <div class="col-8">
                                <div>
                                    <apexchart
                                        v-if="!loading"
                                        class="apex-charts"
                                        height="40"
                                        type="area"
                                        dir="ltr"
                                        :series="series.packet_loss"
                                        :options="chartOptions"
                                    ></apexchart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-server h2 text-primary align-middle mb-0 mr-3"></i> Liczba kanałów
                        </p>

                        <div class="row">
                            <div class="col-4 d-flex justify-content-center align-items-center">
                                <h3>{{ data.serverStats[0].channels }}</h3>
                            </div>
                            <div class="col-8">
                                <div>
                                    <apexchart
                                        v-if="!loading"
                                        class="apex-charts"
                                        height="40"
                                        type="area"
                                        dir="ltr"
                                        :series="series.channels"
                                        :options="chartOptions"
                                    ></apexchart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!loading">
            <div class="col-md-12 d-md-none mt-5">
                <h3>Aktualności</h3>
                <hr>
            </div>
            <div class="col-md-9">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-newspaper"></i> Aktualności
                    </div>
                    <div class="card-body">
                        <div v-if="data.news.length" >
                            <div class="news" v-for="singleNews in data.news" :key="singleNews.id">
                                <div class="d-flex justify-content-between align-items-center flex-row">
                                    <h3>{{ singleNews.title }}</h3>
                                    <span v-if="singleNews.only_admins">
                                        <i :id="`news-`+singleNews.id" class="fa fa-user-secret text-primary font-size-22"></i>
                                        <b-tooltip :target="`news-`+singleNews.id" placement="top" noninteractive>
                                            Ten news jest widoczny tylko dla administratorów
                                        </b-tooltip>
                                    </span>
                                </div>
                                <hr>
                                <p v-html="singleNews.content"></p>
                                <div class="news-footer">
                                    <client :client="singleNews.client" withAvatar/>
                                    <small>
                                        {{ singleNews.created_at | moment("DD-MM-YYYY HH:mm") }}
                                        <span v-if="singleNews.updated_at != singleNews.created_at">
                                        (Edytowany: {{ singleNews.updated_at | moment("DD-MM-YYYY HH:mm") }})
                                    </span>
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <h5 class="text-center">Na razie nie mamy żadnych aktualności</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 d-md-none mt-3">
                <h3>Administracja</h3>
                <hr>
            </div>

            <div class="col-md-3">
                <div v-for="info in data.admins" :key="info.group.sgid" class="card">
                    <div class="card-header">
                        <server-group :group="info.group" withName/>
                    </div>
                    <div class="card-body">
                        <client v-for="admin in info.clients" :key="admin.dbid" :client="admin" withAvatar class="py-3"/>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DashboardService from "@/services/dashboard.service";

export default {
    name: "Home",
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            title: "Home",
            items: [
                {
                    text: "Home",
                    active: true,
                },
            ],
            loading: true,
            series: {
                online: [{
                    name: 'Online',
                    data: []
                }],
                ping: [{
                    name: 'Ping',
                    data: []
                }],
                packet_loss: [{
                    name: 'Utrata pakietów',
                    data: []
                }],
                channels: [{
                    name: 'Liczba kanałów',
                    data: []
                }],
            },
            chartOptions: {
                chart: {
                    type: 'area',
                    height: 40,
                    sparkline: {
                        enabled: true
                    }
                },
                stroke: {
                    curve: 'smooth',
                    width: 2,
                },
                colors: [],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        inverseColors: false,
                        opacityFrom: 0.45,
                        opacityTo: 0.05,
                        stops: [25, 100, 100, 100]
                    },
                },
                tooltip: {
                    fixed: {
                        enabled: false
                    },
                    x: {
                        show: false
                    },
                    marker: {
                        show: false
                    }
                }
            },
            data: {}
        }
    },
    computed: {
        cfg() {
            return this.$store.getters['cfg/get'];
        }
    },
    mounted() {
        this.chartOptions.colors.push(this.cfg.global.theme.primaryColor);
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;

            DashboardService.getData().then(
                response => {
                    this.data = response.data;

                    this.setStats();
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        setStats() {
            this.data.serverStats.forEach(stat => {
                this.series.online[0].data.push(stat.online);
                this.series.ping[0].data.push(stat.ping);
                this.series.packet_loss[0].data.push(stat.packet_loss);
                this.series.channels[0].data.push(stat.channels);
            });

            this.series.online[0].data.reverse();
            this.series.ping[0].data.reverse();
            this.series.packet_loss[0].data.reverse();
            this.series.channels[0].data.reverse();
        }
    }
}
</script>

<style scoped>

</style>